/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderShippingMethod
 */
export interface OrderShippingMethod {
    /**
     * 
     * @type {boolean}
     * @memberof OrderShippingMethod
     */
    isDefault?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrderShippingMethod
     */
    remoteId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderShippingMethod
     */
    name?: string;
}

/**
 * Check if a given object implements the OrderShippingMethod interface.
 */
export function instanceOfOrderShippingMethod(value: object): value is OrderShippingMethod {
    return true;
}

export function OrderShippingMethodFromJSON(json: any): OrderShippingMethod {
    return OrderShippingMethodFromJSONTyped(json, false);
}

export function OrderShippingMethodFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderShippingMethod {
    if (json == null) {
        return json;
    }
    return {
        
        'isDefault': json['isDefault'] == null ? undefined : json['isDefault'],
        'remoteId': json['remoteId'] == null ? undefined : json['remoteId'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function OrderShippingMethodToJSON(json: any): OrderShippingMethod {
    return OrderShippingMethodToJSONTyped(json, false);
}

export function OrderShippingMethodToJSONTyped(value?: OrderShippingMethod | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isDefault': value['isDefault'],
        'remoteId': value['remoteId'],
        'name': value['name'],
    };
}

